import { render, staticRenderFns } from "./SvgBar.vue?vue&type=template&id=06851faa&scoped=true"
import script from "./SvgBar.vue?vue&type=script&lang=js"
export * from "./SvgBar.vue?vue&type=script&lang=js"
import style0 from "./SvgBar.vue?vue&type=style&index=0&id=06851faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06851faa",
  null
  
)

export default component.exports